import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useRef } from "react";
import ChangeEmailForm from "./ChangeEmailForm";

const ChangeEmailModal = ({ isOpen, onOpen, onClose }) => {
  const formRef = useRef(); // Create a ref to access Formik

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit(); // Trigger form submission
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      blockScrollOnMount={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize={"md"}>Change email</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ChangeEmailForm formRef={formRef} onClose={onClose} />
        </ModalBody>

        <ModalFooter display={"flex"} gap={1}>
          <Button variant={"danger-outline"} onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Change my email
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ChangeEmailModal;